<template>
  <div>
    <component ref="comp" :is="device" :sealConfigData="sealConfigData" :nuoSeal="nuoSeal"> </component>
  </div>
</template>

<script>
  /* eslint-disable */
import homePc from './pc.vue'
import homeMb from './mobile.vue'
export default {
  data: function () {
    return {
      device: "home-pc",
    }
  },
  props: {
    sealConfigData: {
      type: [Object, null],
      default: null
    },
    nuoSeal: null
  },
  components: {
    "home-pc": homePc,
    "home-mb": homeMb,
  },
  created: function () {
    this.getDevice()
  },
  methods: {
    getDevice: function () {
      if (
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        this.device = "home-mb"
      } else {
        this.device = "home-pc"
      }
    },
  },
}
</script>

<style></style>
